import Util from '@/assets/libs/util.js'

const ajustProductToOpen = function (product) {
  const curProd = product

  curProd.productGroups.forEach(p => delete p.listed)
  curProd.productComboBkp = curProd.productCombo ? Util.deepCopy(curProd.productCombo) : []
  curProd.observationsBkp = curProd.observations ? Util.deepCopy(curProd.observations) : []
  curProd.productGroupsBkp = curProd.productGroups ? Util.deepCopy(curProd.productGroups) : []
  curProd.productComboRawBkp = curProd.productComboRaw ? Util.deepCopy(curProd.productComboRaw) : []

  if (curProd && curProd.productCode) {
    curProd.quantity = curProd.quantity || 1
    curProd.totalItemPrice = curProd.edited ? parseFloat(curProd.totalItemPrice) : parseFloat(curProd.price)

    curProd.observations = curProd.edited ? curProd.observations : []
    curProd.observationsChoice && curProd.observationsChoice.forEach(obc => {
      (obc.observations || []).forEach(obs => {
        obs.obsGroupCode = obc.obsGroupCode
      })
    })

    // Se o usuário entrou nesta tela para editar um produto, este bloco atualiza as quantidades no
    // array observationsChoice de acordo com as quantidades no array observations, caso necessário
    if (curProd.observations.length > 0) {
      curProd.observations.forEach(obs => {
        if (obs.quantity !== undefined && obs.quantity > 0) {
          for (let i = 0; i < curProd.observationsChoice.length; i++) {
            const obsIndex = curProd.observationsChoice[i].observations.findIndex(element => {
              return element.obsCode === obs.obsCode &&
                                element.obsGroupCode === obs.obsGroupCode &&
                                element.obsName === obs.obsName &&
                                element.price === obs.price
            })
            if (obsIndex !== -1) {
              curProd.observationsChoice[i].observations[obsIndex].quantity = obs.quantity
            }
          }
        }
      })
    }

    curProd.productCombo = curProd.edited ? curProd.productCombo : []
  }
  return curProd
}

const priceUpdate = function (prod) {
  const isComboProduct = prod.productGroups && prod.productGroups.length > 0
  const printFather = prod.productPrint === 'S'

  // Trata o preco do item principal (pai) ou item simples
  if (!isComboProduct || printFather) {
    prod.totalItemPrice = parseFloat(prod.price)
  } else {
    // Se o produto principal é imprime não, seu preço deve ser zerado
    // (para cálculo do preço total e também para transmitir zerado para a Odhen Interface)
    prod.price = 0
    prod.totalItemPrice = 0
  }

  // Trata o preco das observacoes
  prod.observations.forEach(o => {
    const multiplier = o.quantity === undefined ? 1 : o.quantity
    prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat((o.price * multiplier) || 0)) * 100) / 100
  })

  // Trata o preco dos itens filhos
  prod.productCombo.forEach(o => {
    const printChildGroup = o.groupPrint === 'S'
    const multiplier = o.quantity ? o.quantity : 1
    const fatherProductCode = prod.productCode
    const isFosException = Util.isFosException(o, fatherProductCode, printFather, printChildGroup)

    if ((!printFather && !isFosException) || (printFather && printChildGroup && !isFosException)) {
      prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(o.price * multiplier || 0)) * 100) / 100
    } else {
      // Zera o preco dos itens de combo que nao devem ter o preco considerado, para depois transmitir zerado para a Odhen Interface
      o.price = 0
    }

    // Trata os preços das observações de itens filhos
    if (o.observations && o.observations.length > 0) {
      o.observations.forEach(obs => {
        const obsPrice = obs.price ? obs.price : 0
        const obsMultiplier = obs.quantity ? obs.quantity : 1
        prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(obsPrice * obsMultiplier * multiplier || 0)) * 100) / 100
      })
    }

    // Trata os preços do Combo do Combo
    if (o.choosen) {
      const imprimePaiComboDoCombo = o.firstLevelFatherPrint === 'S'
      const keys = Object.keys(o.choosen)

      keys.forEach(key => {
        const currentComboComboChilds = o.choosen[key]

        if (currentComboComboChilds.length > 0) {
          currentComboComboChilds.forEach(child => {
            const imprimeFilhoComboDoCombo = child.groupPrint === 'S'
            const multiplier = child.quantity ? child.quantity : 1

            if (!imprimePaiComboDoCombo || (imprimePaiComboDoCombo && imprimeFilhoComboDoCombo)) {
              prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(child.price * multiplier || 0)) * 100) / 100
            } else {
              // Zera o preco dos itens de combo que nao devem ter o preco considerado, para depois transmitir zerado para a Odhen Interface
              child.price = 0
            }

            // Trata os preços das observações do combo do combo
            if (child.observations && child.observations.length > 0) {
              child.observations.forEach(obs => {
                const obsPrice = obs.price ? obs.price : 0
                const obsMultiplier = obs.quantity ? obs.quantity : 1
                prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(obsPrice * obsMultiplier * multiplier || 0)) * 100) / 100
              })
            }
          })
        }
      })
    }
  })
}

export default {
  ajustProductToOpen,
  priceUpdate
}
